import { SVGProps } from 'react';

import clsx from 'clsx';

import { IconName } from '@/common/icons/CriticalIcons/CriticalIcon.enum';
import { IconSize } from '@/common/icons/icon.interface';

import styles from './criticalIcon.module.scss';

interface CriticalIconProps extends Omit<SVGProps<SVGElement>, 'ref'> {
  name: IconName;
  size?: IconSize;
  className?: string;
  color?: string;
  dataTestId?: string;
}

const CriticalIcon = ({
  color,
  name,
  size = IconSize.SIZE24,
  className,
  dataTestId,
  ...props
}: CriticalIconProps): JSX.Element => {
  return (
    <svg
      className={clsx(styles.icon, className)}
      data-testid={dataTestId || 'icon'}
      style={{ color: color || 'currentColor', minWidth: size, minHeight: size }}
      {...props}
      height={size}
      viewBox={`0 0 ${size} ${size}`}
      width={size}
    >
      <use xlinkHref={`#icon_${name}`} />
    </svg>
  );
};

export default CriticalIcon;
